/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const generateCampaignFormalitySchema = z.union([z.literal('informal'), z.literal('formal'), z.literal(null)])

export type GenerateCampaignFormalitySchema = z.infer<typeof generateCampaignFormalitySchema>
